module.exports = __webpack_public_path__ + "img/hc_pro_ten_14.298c931b.jpg";